
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-coins-line',
      title: 'Asset Liquidation',
      description: 'Strategic disposition of corporate and industrial assets to maximize recovery value.',
    },
    {
      icon: 'ri-clipboard-line',
      title: 'Inventory Management',
      description: 'Specialized tracking and organizational solutions for surplus stock.',
    },
    {
      icon: 'ri-handshake-line',
      title: 'Direct Asset Sales',
      description: 'A curated marketplace for high-quality pre-owned industrial and commercial equipment.',
    },
  ];

  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="mb-20">
          <div className="flex items-center space-x-2 mb-4">
            <span className="w-2 h-2 bg-gold rounded-full"></span>
            <span className="text-gold text-xs tracking-[3px] uppercase font-semibold">Our Expertise</span>
          </div>
          <h2 className="text-white text-5xl md:text-6xl font-bold leading-tight">
            Comprehensive Asset<br />Solutions
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-darkCard border-t-[3px] border-gold p-8 rounded-lg hover:transform hover:scale-105 hover:shadow-2xl hover:shadow-gold/20 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-gold text-5xl`}></i>
              </div>
              <h3 className="text-white text-2xl font-bold mb-4">{service.title}</h3>
              <p className="text-lightGray text-base leading-relaxed mb-6">
                {service.description}
              </p>
              <a
                href="mailto:info@nextlifeasset.com"
                className="text-gold hover:text-warmGold transition-colors inline-flex items-center space-x-2 font-semibold cursor-pointer whitespace-nowrap"
              >
                <span>Learn More</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
